export default __webpack_public_path__ + "static/media/spesifikasi-mesin-agate.2181d79f.png";